import Topo from "../../Componentes/TopCategorias"
import { useStyles } from "./style"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import BannerSejaPro from "../../Componentes/BannerSejaPro"
import { useHistory } from "react-router-dom"

export function SuporteTecnicoPage() {
    const classes = useStyles()
    const phoneNumber = '551152004015'; 
    const history = useHistory();
  
    const handleRedirectToWhatsapp = () => {
      const url = `https://wa.me/${phoneNumber}`;
      window.open(url, '_blank');
    };

    return (
        <div className="page-container">
            <div className="page-align" style={{ justifyContent: "flex-start" }}>
                <div>
                    <Topo rota={"/home/left-menu"} name="Suporte Técnico" />
                </div>
                <div className="infinite-scroll">
                    <div className={classes.container}>
                        <div className={classes.buttonsContainer}>
                            <div className={classes.redirectButton} onClick={() => history.push("suporte-tecnico/chamado-tecnico")}>
                                <div>
                                    <span className={classes.redirectButtonTitle}>
                                        Abrir um chamado técnico
                                    </span>
                                    <p className={classes.redirectButtonDescription}>
                                        Solicite suporte técnico especializado para
                                        lhe ajudarmos da melhor forma possível
                                    </p>
                                </div>
                                <ArrowForwardIosIcon fontSize="small" color="disabled" />
                            </div>
                            <div className={classes.redirectButton} onClick={handleRedirectToWhatsapp}>
                                <div>
                                    <span className={classes.redirectButtonTitle}>
                                        Atendimento via whatsapp
                                    </span>
                                    <p className={classes.redirectButtonDescription}>
                                        Faça contato com o nosso time via whatsapp
                                    </p>
                                </div>
                                <ArrowForwardIosIcon fontSize="small" color="disabled" />
                            </div>
                        </div>
                        <BannerSejaPro />
                    </div>
                </div>
            </div>
        </div>
    )
}